import { Box, Collapse, Heading, HStack, IconButton, Stack, StackProps, useDisclosure } from "@chakra-ui/react";

import { ChevronDownIcon } from "../Icons/Icons";

export interface CollapseCardProperties extends Omit<StackProps, "title"> {
  defaultOpened?: boolean;

  title?: React.ReactNode;
}

export const CollapseCard: React.FunctionComponent<CollapseCardProperties> = ({
  children,
  defaultOpened = true,
  title,
  ...rest
}) => {
  const { isOpen, onToggle } = useDisclosure({
    defaultIsOpen: defaultOpened,
  });

  return (
    <Stack
      bg="white"
      borderRadius="lg"
      margin={0}
      overflow={isOpen ? "visible" : "hidden"}
      shadow={isOpen ? "md" : "none"}
      spacing={0}
      transition="box-shadow 0.3s ease"
      width="100%"
      willChange="box-shadow"
      {...rest}
    >
      <HStack
        _hover={{
          bg: "gray.100",
        }}
        borderBottom={isOpen ? "2px" : undefined}
        borderColor="brand.500"
        borderTopRadius="lg"
        color="gray.700"
        cursor="pointer"
        onClick={() => onToggle()}
        px="4"
        py="3"
        transition="background 0.1s ease-out"
        willChange="background"
      >
        <Heading flexGrow={1} fontSize="lg" fontWeight="medium">
          {title}
        </Heading>
        <IconButton
          aria-label={isOpen ? "Collapse" : "Expand"}
          bg="transparent !important"
          colorScheme="gray"
          icon={<ChevronDownIcon />}
          rounded="full"
          size="md"
          transform={isOpen ? "rotate(180deg)" : "rotate(0deg)"}
          transition="transform 0.3s ease-out"
          willChange="transform"
        />
      </HStack>
      <Collapse in={isOpen} style={{ overflow: isOpen ? "visible" : "hidden" }}>
        <Box bg="white" borderRadius="0 0 8px 8px" padding={4}>
          {children}
        </Box>
      </Collapse>
    </Stack>
  );
};
